"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var view_models_1 = require("./../view-models");
var validators_1 = require("./../validators");
var CoverageFormService = (function () {
    function CoverageFormService(fb) {
        this.fb = fb;
        this.date1Label = 'Pickup Date';
        this.date2Label = 'Dropoff Date';
        this.date1FormControlName = 'pickupDate';
        this.date2FormControlName = 'dropoffDate';
    }
    CoverageFormService.prototype.buildCoverageFormArray = function (formArray, configuration, overrideValidation) {
        if (overrideValidation === void 0) { overrideValidation = false; }
        configuration.date1Label = this.date1Label;
        configuration.date2Label = this.date2Label;
        configuration.date1FormControlName = this.date1FormControlName;
        configuration.date2FormControlName = this.date2FormControlName;
        var _loop_1 = function (i) {
            var coverageFormGroup = new forms_1.FormGroup({});
            coverageFormGroup.addControl('selected', this_1.fb.control(configuration.optionalCoverages[i].isSelected));
            if (view_models_1.CoverageViewModel.canAddLimitControl(configuration.optionalCoverages[i])) {
                coverageFormGroup.addControl('limitSelection', this_1.fb.control(configuration.optionalCoverages[i].coverageLimit));
            }
            if (view_models_1.CoverageViewModel.hasDates(configuration.optionalCoverages[i])) {
                var pickupDateValidators_1 = [];
                var dropoffDateValidators_1 = [];
                // Set up control for CRCC
                coverageFormGroup.addControl('carRentalCompany', this_1.fb.control(configuration.carRentalCompany));
                // Now we are going to set up the date for pickup date
                pickupDateValidators_1.push(forms_1.Validators.required);
                pickupDateValidators_1.push(validators_1.departureDateValidator(configuration.tripReturnDate, configuration.tripDepartureDate, overrideValidation));
                // Add pickup date control if it is selected add the validators
                if (configuration.optionalCoverages[i].isSelected) {
                    coverageFormGroup.addControl(this_1.date1FormControlName, this_1.fb.control(configuration.pickupDate, forms_1.Validators.compose(pickupDateValidators_1)));
                }
                else {
                    coverageFormGroup.addControl(this_1.date1FormControlName, this_1.fb.control(configuration.pickupDate));
                }
                // Now we are going to set up the date for pickup date
                dropoffDateValidators_1.push(forms_1.Validators.required);
                dropoffDateValidators_1.push(validators_1.returnDateValidator(coverageFormGroup.controls['pickupDate'], configuration.tripReturnDate, configuration.tripDepartureDate, overrideValidation));
                if (configuration.optionalCoverages[i].isSelected) {
                    // Add pickup date control
                    coverageFormGroup.addControl(this_1.date2FormControlName, this_1.fb.control(configuration.dropoffDate, forms_1.Validators.compose(dropoffDateValidators_1)));
                }
                else {
                    coverageFormGroup.addControl(this_1.date2FormControlName, this_1.fb.control(configuration.dropoffDate));
                }
                coverageFormGroup.controls['pickupDate'].valueChanges.subscribe(function (newValue) {
                    // when the value of the pickupDate date control changes, run
                    // validation on dropoffDate control
                    coverageFormGroup.controls['dropoffDate'].updateValueAndValidity();
                });
                // Check the selection of Date Forms,  if it is not selected do not check validity
                coverageFormGroup.controls['selected'].valueChanges.subscribe(function (newValue) {
                    if (newValue === true) {
                        coverageFormGroup.controls['pickupDate'].setValidators(pickupDateValidators_1);
                        coverageFormGroup.controls['dropoffDate'].setValidators(dropoffDateValidators_1);
                    }
                    else {
                        // https://scotch.io/tutorials/how-to-implement-conditional-validation-in-angular-2-model-driven-forms
                        coverageFormGroup.controls['pickupDate'].setValidators(null);
                        coverageFormGroup.controls['dropoffDate'].setValidators(null);
                        coverageFormGroup.controls['pickupDate'].setValue(null);
                        coverageFormGroup.controls['dropoffDate'].setValue(null);
                    }
                    coverageFormGroup.controls['pickupDate'].updateValueAndValidity();
                    coverageFormGroup.controls['dropoffDate'].updateValueAndValidity();
                });
            }
            formArray.push(coverageFormGroup);
        };
        var this_1 = this;
        for (var i = 0; i <= configuration.optionalCoverages.length - 1; i++) {
            _loop_1(i);
        }
    };
    // builds controls necessary for toggling coverages
    CoverageFormService.prototype.buildCoverageForm = function (configuration, overrideValidation) {
        if (overrideValidation === void 0) { overrideValidation = false; }
        var tempControls = new forms_1.FormArray([]);
        this.buildCoverageFormArray(tempControls, configuration, overrideValidation);
        return tempControls;
    };
    CoverageFormService.prototype.findWithAttr = function (array, attr, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    };
    return CoverageFormService;
}());
CoverageFormService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [forms_1.FormBuilder])
], CoverageFormService);
exports.CoverageFormService = CoverageFormService;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/coverage-form.service.js